import { createContext } from 'react';

import { RouterValues } from './types';

export const RouterContext = createContext<RouterValues>({ isFirstView: true });
